import React from 'react';
import { TeamMembersPanel } from '@/components/team/TeamMembersPanel';

const ROLES = [
  { value: 'fwtv_admin',     label: 'FWTV Admin',    is_admin_role: true,
     description: 'Team, channels, live, VOD, podcasts, transcripts, analytics, prayer inbox.' },
  { value: 'fwtv_producer',  label: 'FWTV Producer',
     description: 'Schedule live streams, publish VOD, manage podcasts and transcripts.' },
  { value: 'fwtv_editor',    label: 'FWTV Editor', is_default: true,
     description: 'Upload / edit VOD, edit sermon metadata and transcripts.' },
  { value: 'fwtv_moderator', label: 'FWTV Moderator',
     description: 'Moderate prayer inbox and comments.' },
  { value: 'viewer',         label: 'Viewer',
     description: 'Read-only analytics dashboard.' },
];

export default function FwtvTeamPage() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200">
      <TeamMembersPanel
        apiPath="fwtv"
        roles={ROLES}
        title="Faith Works TV — Team"
        description="Manage the FWTV production crew — producers, editors and moderators. Backed by /api/fwtv/team."
      />
    </div>
  );
}
